import { Link } from 'react-router-dom';
import { useHistoryQuery } from '@platform/state/api';
import { relativeTime } from '@platform/core/lib/format';
import { routes } from '@platform/core/lib/routes';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useRecordTypeLabels } from '@platform/features/search/useRecordTypeLabels';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IActivityRowProps } from './IActivityRowProps';
import { initials } from './initials';
import { useActivityText } from './useActivityText';

/**
 * Рядок «Нещодавньої активності» (прототип v4 G:L1572): ініціали автора в колі 24px (--surface2), «<b>Хто</b> що зробив» і під ним 11px
 * «номер · назва · коли» (голий номер, як у прототипі) — остання подія історії запису (без історії — створення запису); відкриває запис.
 */
export function ActivityRow({ record }: IActivityRowProps) {
  const lang = useAppSelector(selectLang);
  const { data: history } = useHistoryQuery({ recordId: record.id });
  const labels = useRecordTypeLabels(record.module, record.recordType);
  const textOf = useActivityText();
  const entry = history?.[0];
  const who = entry?.actor?.name ?? record.createdBy?.name ?? '';
  const text = entry ? textOf(entry, (v) => labels.status(v).label) : textOf({ id: 0, at: record.createdAt, kind: 'created', mergedCount: 0 }, (v) => v);
  return (
    <Link className="hp-act" to={routes.record(record.module, record.recordType, record.id)}>
      <span className="hp-act__avatar" aria-hidden="true">{initials(who)}</span>
      <span className="hp-act__text">
        <span className="hp-act__title"><b>{who}</b> {text}</span>
        <span className="hp-act__meta" title={record.display}>{[recordNumber(record), record.title, relativeTime(entry?.at ?? record.updatedAt, lang)].filter(Boolean).join(' · ')}</span>
      </span>
    </Link>
  );
}
